/*
 * Makerz quick add for collection cards.
 * Event delegation on document, so cards appended by infinite scroll work too.
 * Adds via /cart/add.js and hands the response to the theme's <cart-drawer>,
 * which re-renders and opens. Without a drawer (e.g. on /cart) it falls back
 * to the cart page.
 */
(() => {
  if (window.__skQuickAddLoaded) return;
  window.__skQuickAddLoaded = true;

  const ADDED_MS = 1400;
  const ERROR_MS = 4000;

  const cartAddUrl = () => ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
  const cartUrl = () => (window.routes && window.routes.cart_url) || '/cart';

  function closePanel(root, restoreFocus) {
    if (!root) return;
    const panel = root.querySelector('.skqa__panel');
    const toggle = root.querySelector('[data-skqa-toggle]');
    if (!panel || panel.hidden) return;
    panel.hidden = true;
    root.classList.remove('is-open');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      if (restoreFocus) toggle.focus();
    }
  }

  function closeAllPanels(except) {
    document.querySelectorAll('[data-skqa].is-open').forEach((root) => {
      if (root !== except) closePanel(root, false);
    });
  }

  function openPanel(root) {
    const panel = root.querySelector('.skqa__panel');
    const toggle = root.querySelector('[data-skqa-toggle]');
    if (!panel) return;
    closeAllPanels(root);
    panel.hidden = false;
    root.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    const first = panel.querySelector('.skqa__chip:not([disabled])');
    if (first) first.focus({ preventScroll: true });
  }

  function showError(root, message) {
    const el = root.querySelector('.skqa__error');
    if (!el) return;
    el.textContent = message || 'Varen kunne ikke tilføjes. Prøv igen.';
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(() => { el.hidden = true; }, ERROR_MS);
  }

  async function addToCart(variantId, trigger, root) {
    const btn = root.querySelector('.skqa__btn');
    if (!variantId || btn.classList.contains('is-loading')) return;

    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    if (trigger !== btn) trigger.classList.add('is-loading');

    const cart = document.querySelector('cart-drawer');
    const body = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map((s) => s.id).join(',');
      body.sections_url = window.location.pathname;
    }

    try {
      const res = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body),
      });
      const json = await res.json();

      if (!res.ok || json.status) {
        showError(root, json.description || json.message);
        return;
      }

      closePanel(root, false);
      btn.classList.add('is-added');
      setTimeout(() => btn.classList.remove('is-added'), ADDED_MS);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', productVariantId: variantId });
      }

      if (cart && typeof cart.renderContents === 'function') {
        cart.setActiveElement && cart.setActiveElement(btn);
        cart.renderContents(json);
      } else {
        window.location.href = cartUrl();
      }
    } catch (e) {
      console.error('[quick add]', e);
      showError(root);
    } finally {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      trigger.classList.remove('is-loading');
    }
  }

  document.addEventListener('click', (event) => {
    const target = event.target;
    const root = target.closest('[data-skqa]');

    if (!root) {
      closeAllPanels(null);
      return;
    }

    const addBtn = target.closest('[data-skqa-add]');
    if (addBtn) {
      event.preventDefault();
      addToCart(addBtn.dataset.skqaAdd, addBtn, root);
      return;
    }

    const toggle = target.closest('[data-skqa-toggle]');
    if (toggle) {
      event.preventDefault();
      root.classList.contains('is-open') ? closePanel(root, true) : openPanel(root);
      return;
    }

    if (target.closest('[data-skqa-close]')) {
      event.preventDefault();
      closePanel(root, true);
      return;
    }

    const chip = target.closest('[data-skqa-variant]');
    if (chip && !chip.disabled) {
      event.preventDefault();
      addToCart(chip.dataset.skqaVariant, chip, root);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const root = event.target.closest && event.target.closest('[data-skqa].is-open');
    if (root) closePanel(root, true);
  });
})();
